import parseUrlRegion from './parseUrlRegion';
import marked from 'marked';
import richtext from './richtext';
import { humanizedReadingTime, fixedReadingTime } from './readingTime';

// Removes the `/us` for global pages and returns the parsed url.
// Use `isSlug` = true when generating the slug component.
export const parsePostUrl = (url, isSlug = false) => {
  return isSlug ? parseUrlRegion(url).substring(1) : parseUrlRegion(url);
};

// Gets the relevant post date
export const getPostDate = post => {
  if (post.content.post_date) {
    return post.content.post_date;
  }
  if (post.updated_at) {
    return post.updated_at;
  }
  if (post.published_at !== null) {
    return post.published_at;
  }

  return post.created_at;
};

// Gets the humanized reading time (in minutes) of a blog post
export const getPostReadingTime = (postContents, numberOnly = false) => {
  let postHtmlContents = '';
  postContents.map(postContent => {
    if (postContent.component === 'cms-blog-richtext') {
      if (typeof postContent.content === 'string') {
        postHtmlContents += marked(postContent.content);
      } else {
        postHtmlContents += richtext(postContent.content);
      }
    }
  });
  return numberOnly
    ? fixedReadingTime(postHtmlContents)
    : humanizedReadingTime(postHtmlContents);
};
